import basicRequest from "../../../core/redux/actions/request";
import { notification } from "antd";

const PREFIX = "CACHE_CURRENCY";
const getState = (state) => state.cache.currency;

/**
 * BASIC REQUEST
 */
const {
    reset: resetCacheCurrency,

    getCachePattern,
    getCacheUnrestrictedPattern,

    isLoaded: isCacheCurrencyLoaded,
    isLoading: isCacheCurrencyLoading,
    getError: getCacheCurrencyError,
    getData,
} = basicRequest(PREFIX, getState);

/**
 * Load Cache from API
 */
//export const loadCacheCurrency = () => getCachePattern("public/cache/v1/currencies", {});
export const loadCacheCurrency = () => getCacheUnrestrictedPattern("public/cache/v1/currencies", {});

/**
 * Selectors for RAW data
 */
const getCurrencies = (state) => (isCacheCurrencyLoaded(state) ? getData(state).currencies : []);

/**
 * Generic function to create an array indexed by id
 *
 * TODO:
 *    - Should be a function ? ( errores when ids outside of its domain )
 *    - Should be in the reducer ?
 */
const getById = (list) => {
    return list.reduce((acc, cur) => ({ ...acc, [cur.id]: cur }), {});
};

/**
 * Selectors for display data for a specific ID
 */
export const getCurrenciesById = (state) => getById(getCurrencies(state));

export const getCurrenciesForSelect = (state) => {
    const list = getCurrencies(state).filter((item) => item.active);
    return (list || []).map((item) => {
        return { ...item, value: item.id, label: item.name };
    });
};

/**
 * Private function to trigger a reset in the cache and display a message
 */
const onChangeSuccessfully = (message) => (dispatch) => {
    notification.success(message);
    dispatch(resetCacheCurrency());
};

/**
 * Public interfaces for request an update in the cache
 */
export const onChangeInCurrencies = onChangeSuccessfully;

export { isCacheCurrencyLoaded, isCacheCurrencyLoading, getCacheCurrencyError };
